import { render } from "./ViewDetail.vue?vue&type=template&id=52e5395d&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"

import "./ViewDetail.vue?vue&type=style&index=0&id=52e5395d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5395d"]])

export default __exports__